import { TravelForm } from "./TravelForm";

export function TravelCreatePage() {
  return <TravelForm mode="create" />;
}
